/// <amd-module name="CodeCoverage/CodeCoverageTab/Stores/BuildCodeCoverageStore" />
import { CodeCoverageTabActionHub, IBuildCodeCoverageDetails, IFolderViewBuildCodeCoverageDetails } from 'Actions/CodeCoverageTabActionHub';
import { Store } from 'VSS/Reflux/Store';
import * as Resources from 'CodeCoverage/CodeCoverageTab/Resources';


export interface IBuildCodeCoverageState {
    showCodeCoverageHTMLSummary: boolean;
    codeCoverageSummaryLink: string;
    modernBrowserAvailable: boolean;
    buildCodeCoverageDetails: IBuildCodeCoverageDetails;
    moduleFilterText: string;
    showCodeCoverageDetails: boolean,
    selectedBuildConfiguration: number;
    messageAreaText: string;
    codeCoverageFailureMessage: string;
    folderViewEnabled: boolean;
    folderViewBuildCodeCoverageDetails: IFolderViewBuildCodeCoverageDetails;
    selectedFolderViewBuildConfiguration: number;
}

export class BuildCodeCoverageStore extends Store {
	constructor(private changeEvent: string, private _actionsHub: CodeCoverageTabActionHub) {
		super(changeEvent);
        this._initialize();
    }
    
    public getState() {
        return this._state;
    }

    private _initialize(): void {
        this._state = this._getDefaultState();
        this._actionsHub.updateBuildConfigSelection.addListener(this._updateConfigSelectorState);
        this._actionsHub.updateBuildCodeCoverage.addListener(this._updateBuildCodeCoverage);
        this._actionsHub.updateCodeCoverageSummary.addListener(this._updateCodeCoverageSummary);
        this._actionsHub.updateModuleFilterText.addListener(this._updateModuleFilterText);
        this._actionsHub.updateNoCodeCoverageMessage.addListener(this._updateNoCodeCoverageMessage);
        this._actionsHub.updateCodeCoverageFailureMessage.addListener(this._updateCodeCoverageFailureMessage);
        this._actionsHub.updateEnableFolderViewState.addListener(this._updateEnableFolderViewState);
        this._actionsHub.updateFolderViewBuildCodeCoverage.addListener(this._updateFolderViewBuildCodeCoverage);
        this._actionsHub.updateFolderViewBuildConfigSelection.addListener(this._updateFolderViewConfigSelectorState);
    }

    private _getDefaultState(): IBuildCodeCoverageState {
        return {
            showCodeCoverageHTMLSummary: false,
            codeCoverageSummaryLink: "",
            buildCodeCoverageDetails: null as any,
            moduleFilterText: "",
            showCodeCoverageDetails: false,
            selectedBuildConfiguration: 0,
            modernBrowserAvailable: this._isSandboxAvailable(),
            messageAreaText: "",
            codeCoverageFailureMessage: "",
            folderViewEnabled: false,
            folderViewBuildCodeCoverageDetails: null as any,
            selectedFolderViewBuildConfiguration: 0
        };
    }

    private _updateBuildCodeCoverage = (codeCoverageDetials: IBuildCodeCoverageDetails)  => { 
        this._state.buildCodeCoverageDetails = codeCoverageDetials;
        this._state.showCodeCoverageDetails = true;
        this._state.showCodeCoverageHTMLSummary = false;

        this.emitChanged();
    }

    private _updateFolderViewBuildCodeCoverage = (folderViewBuildCodeCoverageDetails: IFolderViewBuildCodeCoverageDetails) => {
        this._state.folderViewBuildCodeCoverageDetails = folderViewBuildCodeCoverageDetails;
        this.emitChanged();
    }
    
    private _updateModuleFilterText = (filterText: string)  => { 
        this._state.moduleFilterText = filterText;

        this.emitChanged();
    }

    private _updateCodeCoverageSummary = (summaryLink: string)  => { 

        if (!this._state.modernBrowserAvailable) {
            this._updateNoCodeCoverageMessage(Resources.UpgradeToModernBrowser);
            return;
        }

        this._state.showCodeCoverageHTMLSummary = true;
        this._state.showCodeCoverageDetails = false;
        this._state.codeCoverageSummaryLink = summaryLink;

        this.emitChanged();
    }

    private _updateConfigSelectorState = (index: number) => {
        if (this._state.folderViewEnabled) {
            this._state.selectedFolderViewBuildConfiguration = index;
        } else {
            this._state.selectedBuildConfiguration = index;
        }        
        this.emitChanged();
    }

    private _updateFolderViewConfigSelectorState = (index: number) => {
        this._state.selectedFolderViewBuildConfiguration = index;
        this.emitChanged();
    }

    private _updateNoCodeCoverageMessage = (message: string)  => { 
        this._state.showCodeCoverageHTMLSummary = false;
        this._state.showCodeCoverageDetails = false;
        this._state.messageAreaText = message;

        this.emitChanged();
    }

    private _updateEnableFolderViewState = (state: boolean) => {
        this._state.folderViewEnabled = state;
        this.emitChanged();
    }

    private _updateCodeCoverageFailureMessage = (message: string) => {
        this._state.showCodeCoverageHTMLSummary = false;
        this._state.showCodeCoverageDetails = false;
        this._state.codeCoverageFailureMessage = message;

        this.emitChanged();
    }

    private _isSandboxAvailable(): boolean {
        return "sandbox" in document.createElement("iframe");
    }

    private _state: IBuildCodeCoverageState;
}
